import { theme as default_theme } from "./default";



export const themes = {
    "Default": default_theme,
}